import React from 'react';
import './ServicePages.css';

const ChatbotPage = ({ onContactClick }) => {
  const features = [
    { icon: "💬", title: "Multi-Channel Deployment", desc: "Deploy chatbots across web, mobile, WhatsApp, Slack, and more from a single platform." },
    { icon: "🧠", title: "Context-Aware Conversations", desc: "Bots remember context across sessions, providing personalized and meaningful interactions." },
    { icon: "🌐", title: "Multi-Lingual Support", desc: "Automatically detect and respond in 50+ languages without manual translation." },
    { icon: "⚡", title: "Instant Training", desc: "Train your chatbot on your own documents, FAQs, and knowledge base in minutes." },
    { icon: "📊", title: "Conversation Analytics", desc: "Track engagement, resolution rates, and customer satisfaction with real-time dashboards." },
    { icon: "👥", title: "Seamless Handoff", desc: "Escalate complex queries to human agents with full conversation history preserved." }
  ];

  return (
    <div className="service-page theme-chatbot">
      <section className="svc-hero">
        <div className="svc-hero-content">
          <h1 className="svc-hero-title">Chatbot<br/>Development</h1>
          <p className="svc-hero-subtitle">AI-POWERED CONVERSATIONAL AGENTS FOR EVERY PLATFORM.</p>
          <p className="svc-hero-desc">Build intelligent chatbots that engage customers, automate support, and drive conversions 24/7 across all your channels.</p>
          <div className="svc-hero-stats">
            <div className="svc-stat-item"><h3>90%</h3><p>Query Resolution Rate</p></div>
            <div className="svc-stat-item"><h3>3x</h3><p>Faster Response Time</p></div>
            <div className="svc-stat-item"><h3>60%</h3><p>Support Cost Reduction</p></div>
          </div>
          <div className="svc-hero-cta">
            <button className="svc-btn-primary" onClick={onContactClick}>Book a Call</button>
            <button className="svc-btn-secondary"><span>▶</span> See Demo</button>
          </div>
        </div>
        <div className="svc-hero-visual">
          <div className="svc-glowing-ring">🤖</div>
        </div>
      </section>

      <section className="svc-features-section">
        <h2 className="svc-section-title">Intelligent Chatbot Capabilities</h2>
        <div className="svc-features-grid">
          {features.map((f, i) => (
            <div key={i} className="svc-feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3 className="feature-title">{f.title}</h3>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="svc-cta-section">
        <div className="svc-cta-content">
          <h2>Ready to automate conversations?</h2>
          <p>Book a call and we'll design a chatbot tailored to your business needs.</p>
          <button className="svc-btn-cta" onClick={onContactClick}>Book a Call</button>
        </div>
      </section>
    </div>
  );
};

export default ChatbotPage;
